export enum COMPONENT_TYPE {
  CARD = 'card',
  TAKEOVER = 'takeover',
  TABLE = 'table',
  TAB = 'tab',
  TAKEOVER_TABLE = 'takeover-table',
}
